import React, { Component } from 'react';
import DataTable, { createTheme } from 'react-data-table-component';
import HistoryExpandable from './historyExpandable';
import { windowResize } from '../../utils';
import { Row, Col, Button } from 'react-bootstrap';
import { formatDateDisplay, formatCurrency } from "../../utils";

class BetHistory extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      filter: "all"
    }
  }

  changeFilter(value) {
    this.setState({ filter: value });
  }

  render() {
    createTheme('solarized', {
      text: {
        primary: '#000',
        secondary: '#2aa198',
      },
      context: {
        background: '#cb4b16',
        text: '#000',
      },
      divider: {
        default: '#000',
      },
      action: {
        button: 'rgba(255,255,0,.54)',
        hover: 'rgba(0,0,0,.08)',
        disabled: 'rgba(0,0,0,.12)',
      },
    });

    let betList = {};
    const columns = [
      {
        name: 'Match Name',
        cell: (row) => {
          if (this.props.result == "true") {
            return (
              <div>
                <b>{row['competition_name']}</b>

                <div id={"history-bar-result-inline-" + row['transaction_id']} className="history-bar-result-inline">
                  {
                    betList[row['transaction_id']].map(
                      (b, k) => {
                        return (
                          <span key={k} className={(b['result'] == 1 ? " text-success " : " text-danger ")}>{b['name']}&nbsp;|&nbsp;</span>
                        )
                      }
                    )
                  }
                </div>
              </div>
            );
          } else {
            return (<b>{row['competition_name']}</b>)
          }
        }
      },
      {
        name: 'Jackpot',
        selector: 'jackpot'
      },
    ];

    let dataF = {};

    if(typeof this.props.data !== "undefined"){
      for (let i = 0; i < this.props.data['transactions'].length; i++) {
        let dataK = this.props.data['transactions'][i]['transaction_id'];
        if (typeof dataF[dataK] === "undefined") {
          dataF[dataK] = [];
          betList[dataK] = [];
        }

        betList[dataK].push(this.props.data['transactions'][i]['bets'][0]);

        dataF[dataK].push(
          {
            'competition_name': (this.props.data['transactions'][i]['competition_name'] == "1X2" ? "Market Result(1X2)" : this.props.data['transactions'][i]['competition_name']),
            'jackpot': formatCurrency(this.props.data['transactions'][i]['jackpot']),
            'transaction_result': this.props.data['transactions'][i]['transaction_result'],
            'date': formatDateDisplay(this.props.data['transactions'][i]['date']),
            'transaction_id': this.props.data['transactions'][i]['transaction_id'],
            'match_name': this.props.data['transactions'][i]['match_name'],
            'bets': this.props.data['transactions'][i]['bets'],
            'market_name': (this.props.data['transactions'][i]['market_name'] == "1x2" ? "Market Result(1X2)" : this.props.data['transactions'][i]['market_name']),
            'match_time': formatDateDisplay(this.props.data['transactions'][i]['match_time'])
          }
        )
      }
    }


    let dataF1 = []
    for (let dataFn in dataF) {
      if (this.props.result == "true") {
        if (dataF[dataFn][0]['transaction_result'] > 0) {
          if (this.state.filter == "all") {
            dataF1.push(dataF[dataFn]);
          }
          if (this.state.filter == "win") {
            if (dataF[dataFn][0]['transaction_result'] == 1) {

              dataF1.push(dataF[dataFn]);
            }
          }
          if (this.state.filter == "loss") {
            if (dataF[dataFn][0]['transaction_result'] == 2) {

              dataF1.push(dataF[dataFn]);
            }
          }
        }
      } else {
        if (dataF[dataFn][0]['transaction_result'] == null) {
          dataF1.push(dataF[dataFn]);
        }
      }
    }

    dataF1 = dataF1.reverse();

    return (

      <div>

        {this.props.result == "true" &&
          <Row className="history-completed-filters">
            <Col md="6">
              <Row noGutters>
                <Col xs="3">
                  <h4 className="mb-0 text-filter">Bet history</h4>
                </Col>
                <Col xs={3} md="2">
                  <Button onClick={() => { this.changeFilter("all") }} className={"btn-filter btn-message-bar w-100 text-white btn-info btn-general " + (this.state.filter == "all" ? " active " : "")}>All</Button>
                </Col>
                <Col xs={3} md="2">
                  <Button onClick={() => { this.changeFilter("win") }} className={"btn-filter btn-message-bar w-100 text-white btn-info btn-general " + (this.state.filter == "win" ? " active " : "")}>Win</Button>
                </Col>
                <Col xs={3} md="2">
                  <Button onClick={() => { this.changeFilter("loss") }} className={"btn-filter btn-message-bar w-100 text-white btn-info btn-general " + (this.state.filter == "loss" ? " active " : "")}>Loss</Button>
                </Col>
                <Col md="3"></Col>
              </Row>
            </Col>
          </Row>
        }

        <div className="bar-bets-wrapper">
          {dataF1.map((d, k) => {
            return (
                <Row key={k} className="bg-grey bar-bets">

                <Col md="3" className="bar-bets-date_id">
                  <Row className="no-gutters">
                    <Col md="6">
                      <div>{d[0]['date']}</div>
                    </Col>
                    <Col md="6">
                      <div><b>Bet ID:</b> {d[0]['transaction_id']}</div>
                    </Col>
                  </Row>
                </Col>

                <Col md="4">
                  <div className="">
                    <DataTable
                      className="datatable-bet"
                      columns={columns}
                      data={[d[0]]}
                      expandableRows
                      theme="solarized"
                      onRowExpandToggled={(expanded, row) => {
                        if (document.getElementById("history-bar-result-inline-" + row['transaction_id']) !== null) {
                          if (expanded) {
                            document.getElementById("history-bar-result-inline-" + row['transaction_id']).style.display = "none";
                          } else {
                            document.getElementById("history-bar-result-inline-" + row['transaction_id']).style.display = "block";
                          }
                        }
                        windowResize();
                      }}
                      expandableRowsComponent={<HistoryExpandable key={k} result={this.props.result} dataR={[d]} />}
                    />

                  </div>
                </Col>

                <Col md="3" className="d-sm-none" />

                <Col md="2" className="bar-bets_result">
                  <span className={"not-resulted " + (this.props.result == "true" ? (d[0]['transaction_result'] == 1 ? "text-success" : "text-danger") : "")}>{this.props.result == "true" ? (d[0]['transaction_result'] == 1 ? "Win" : "Loss") : "Not Resulted"}</span>
                </Col>

              </Row>
            )
          })}
        </div>

      </div>
    );
  }
}

export default BetHistory;



// WEBPACK FOOTER //
// ./components/BetTable/history.js